(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marginridge-free-tools"] && !Shopify.designMode) return;
  try {
    
(function(){
  var symbols={GBP:'£',USD:'$',CAD:'C$',AUD:'A$',NZD:'NZ$'};
  function num(form,name){var el=form.elements[name];var value=parseFloat(el&&el.value);return Number.isFinite(value)?value:0}
  function money(value,currency){if(!Number.isFinite(value))return '—';return (symbols[currency]||'')+value.toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2})}
  function pct(value){if(!Number.isFinite(value))return '—';return value.toLocaleString(undefined,{minimumFractionDigits:1,maximumFractionDigits:1})+'%'}
  function set(form,key,value){var el=form.querySelector('[data-out="'+key+'"]');if(el)el.textContent=value}
  function bind(form,calc){if(!form)return;var run=function(event){if(event)event.preventDefault();calc(form)};form.addEventListener('submit',run);form.addEventListener('input',function(){calc(form)});calc(form)}
  bind(document.querySelector('[data-margin-calculator]'),function(form){
    var cost=num(form,'cost'),margin=num(form,'margin'),currency=form.elements.currency.value;
    if(cost<0||margin<=0||margin>=100){set(form,'price','—');set(form,'profit','—');set(form,'markup','—');return}
    var price=cost/(1-margin/100),profit=price-cost,markup=cost?profit/cost*100:0;
    set(form,'price',money(price,currency));set(form,'profit',money(profit,currency));set(form,'markup',pct(markup));
  });
  bind(document.querySelector('[data-profit-calculator]'),function(form){
    var sell=num(form,'sell'),currency=form.elements.currency.value,total=num(form,'labour')+num(form,'materials')+num(form,'subs')+num(form,'other');
    var profit=sell-total,margin=sell?profit/sell*100:0,ratio=sell?total/sell*100:0;
    set(form,'total',money(total,currency));set(form,'profit',money(profit,currency));set(form,'margin',pct(margin));set(form,'ratio',pct(ratio));
  });
  bind(document.querySelector('[data-estimate-calculator]'),function(form){
    var currency=form.elements.currency.value,margin=num(form,'margin'),taxRate=num(form,'tax');
    var total=num(form,'labour')+num(form,'materials')+num(form,'subs')+num(form,'other');
    if(margin<=0||margin>=100){set(form,'total',money(total,currency));set(form,'pretax','—');set(form,'profit','—');set(form,'tax','—');set(form,'quote','—');return}
    var pretax=total/(1-margin/100),profit=pretax-total,tax=pretax*(taxRate/100),quote=pretax+tax;
    set(form,'total',money(total,currency));set(form,'pretax',money(pretax,currency));set(form,'profit',money(profit,currency));set(form,'tax',money(tax,currency));set(form,'quote',money(quote,currency));
  });
})();

  } catch(e) { console.error(e); }
})();
})();
